export const ru = {
    'actuality-author': 'Автор',
    'actuality-links-title': 'Где найти актуальную информацию',
    'actuality-obsolete': 'Страница отмечена как устаревшая',
    'actuality-page-is-actual': 'Страница актуальна',
    'actuality-page-is-obsolete': 'Страница устарела',
    'actuality-possibly-obsolete': 'Страница давно не обновлялась, информация могла устареть.',
    'actuality-show-more': 'Подробнее',
    'button-cancel': 'Закрыть',
    'button-publish': 'Опубликовать',
    'button-save': 'Сохранить',
    'convert-message-cancel': 'Отменить',
    'convert-message-confirm-body': 'Страница будет доступна только в новом редакторе, так как конвертация необратима. Динамические блоки из старого редактора по-другому работают в новом, поэтому их надо будет поправить вручную после конвертации.',
    'convert-message-confirm-cancel': 'Отменить',
    'convert-message-confirm-submit': 'Конвертировать',
    'convert-message-confirm-title': 'Вы собираетесь конвертировать страницу',
    'convert-message-help': 'Конвертация работает только для статических блоков, поэтому оглавление, динамические таблицы, объекты во фрейме или блоки HTML-кода после конвертации придётся поправить вручную',
    'convert-message-old-page': 'Сравнить с исходной',
    'convert-message-preview': 'Предпросмотр сконвертированной страницы',
    'convert-message-submit': 'Конвертировать',
    'delete-redirect': 'Восстановить',
    'error-action-general': 'Обновить страницу',
    'error-action-not-found': 'Создать страницу',
    'error-description-general': 'Попробуйте обновить страницу или обратитесь в службу поддержки',
    'error-description-not-found': 'Этот адрес не занят, вы можете создать здесь новую страницу.',
    'error-get-revision': 'Не удалось загрузить версию страницы',
    'error-get-revisions': 'Не удалось загрузить список версий',
    'error-merge-content': 'Скопируйте свои изменения, обновите страницу и попробуйте внести правки заново',
    'error-merge-title': 'Не удалось объединить изменения',
    'error-merge-unknown-revision': 'Внутренняя ошибка. Скопируйте свои изменения, обновите страницу и попробуйте внести правки заново.',
    'error-moved-pages': 'Страницы, ранее находившиеся по этому адресу, были перенесены:',
    'error-title-general': 'Что-то пошло не так',
    'error-title-not-found': 'По этому адресу ничего нет',
    'error-translate': 'Не удалось перевести страницу',
    'error-update-content': 'Не удалось сохранить страницу',
    'error-update-is-collab': 'Ошибка при обновлении настройки "Совместный режим" ',
    'error-update-redirect': 'Не удалось обновить перенаправление',
    'merge-confirm-message': 'Страницу редактировали одновременно с вами. Хотите объединить изменения?',
    'message-edit': 'Редактировать',
    'message-edit-old-revision': 'Вы редактируете старую версию страницы. Если вы сохраните изменения, отредактированная версия страницы станет актуальной. ',
    'redirect-from-message': 'Вы были перенаправлены со страницы',
    'redirect-page-message': 'Это страница перенаправление, её нельзя редактировать. Вы можете восстановить её, удалив перенаправление',
    'revision-message-author': 'Автор',
    'revision-message-edit-current': 'Вернуть к этой версии',
    'revision-message-last': 'К актуальной версии',
    'revision-message-old-editor': 'недоступна для редактирования после конвертации в новый редактор',
    'revision-message-old-editor-from': 'Эта версия страницы от',
    'revision-message-old-version': 'Это старая версия страницы',
    'revision-message-old-version-from': 'Это старая версия страницы от',
    'service-is-readonly-content': 'Редактирование недоступно из-за проведения технических работ',
    'service-is-readonly-title': 'Редактирование недоступно из-за проведения технических работ',
    'success-update-content': 'Страница сохранена',
    'success-update-is-collab': 'Настройка "Совместный режим" обновлена',
    'success-update-redirect': 'Перенаправление успешно обновлено'
};
